import React from "react";
import port1 from '../assets/images/port1.jpg';
import port2 from '../assets/images/port2.jpg';
import port3 from '../assets/images/port3.jpg';
import port4 from '../assets/images/port4.jpg';
import port5 from '../assets/images/port5.jpg';
import port7 from '../assets/images/port7.jpg';

import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            
            <div className="project">
                <a href="https://github.com/thechristdev/Banking-System-Simulation" target="_blank" rel="noreferrer"><img src={port1} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/thechristdev/Banking-System-Simulation" target="_blank" rel="noreferrer"><h2>Banking System Simulation</h2></a>
                <p>Developed a simulation of a banking system with Python.</p>
            </div>
            <div className="project">
                <a href="https://sites.google.com/view/kelas-xiic-smansaperjaka/beranda" target="_blank" rel="noreferrer"><img src={port2} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://sites.google.com/view/kelas-xiic-smansaperjaka/beranda" target="_blank" rel="noreferrer"><h2>Website Kelas XII-C SMAN Perjaka</h2></a>
                <p>Developed a class website for XII-C students at SMAN Perjaka.</p>
            </div>
            <div className="project">
                <a href="https://github.com/thechristdev/Exposthree-System-Guard" target="_blank" rel="noreferrer"><img src={port3} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/thechristdev/Exposthree-System-Guard" target="_blank" rel="noreferrer"><h2>Exposthree System Guard</h2></a>
                <p>Developed a security system for monitoring and protecting Minecraft servers.</p>
            </div>
            <div className="project">
                <a href="https://lynk.id/visionmultimedia" target="_blank" rel="noreferrer"><img src={port4} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://lynk.id/visionmultimedia" target="_blank" rel="noreferrer"><h2>Vision Multimedia Website</h2></a>
                <p>Developed business website for Vision Multimedia.</p>
            </div>
            <div className="project">
                <a href="https://github.com/thechristdev/Excel-Invoice" target="_blank" rel="noreferrer"><img src={port5} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/thechristdev/Excel-Invoice" target="_blank" rel="noreferrer"><h2>Excel Invoice</h2></a>
                <p>Developed an Excel-based invoice system.</p>
            </div>
            <div className="project">
                <a href="https://github.com/thechristdev/Excel-Personal-Financial-Management" target="_blank" rel="noreferrer"><img src={port7} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/thechristdev/Excel-Personal-Financial-Management" target="_blank" rel="noreferrer"><h2>Excel Personal Financial Management</h2></a>
                <p>Developed an Excel-based personal financial management system.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;